var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Heading from "../../Heading";
import React from 'react';
var componentsMapping = {
    1: Heading.Heading1,
    2: Heading.Heading2,
    3: Heading.Heading3,
};
var HeadingRenderer = function (_a) {
    var level = _a.level, props = __rest(_a, ["level"]);
    var Component = componentsMapping[level] || null;
    return React.createElement(Component, __assign({}, props));
};
export default HeadingRenderer;
//# sourceMappingURL=HeadingRenderer.js.map